import type { FC, ReactNode } from "react";
import { Connection, type ConnectionNavigation } from "./Connection";

type OptimisticConnectionProps = {
  icon: ReactNode;
  name: string;
} & ConnectionNavigation;

export const OptimisticConnection: FC<OptimisticConnectionProps> = props => (
  <Connection
    {...props}
    sx={{
      "opacity": 0,
      "transform": "translate3d(0, -4px, 0)",
      "willChange": "opacity, transform",
      "animation": "connectionFadeIn 400ms cubic-bezier(0.19, 1, 0.22, 1) forwards",
      "@keyframes connectionFadeIn": {
        from: { opacity: 0, transform: "translate3d(0, -4px, 0)" },
        to: { opacity: 1, transform: "translate3d(0, 0, 0)" },
      },
    }}
  />
);
